import { validator } from "@/utils/validator";

export const masterDataAttachmentDocumentTypeSchema = validator.object().shape({
  documentTypeName: validator.string().trim().emptyToNull().label("人材添付書類の種類").required(),
  color: validator.string().isSelection().trim().emptyToNull().label("表示カラー").required(),
});
